export default "__VITE_ASSET__CCcNp1LG__"